export function formatCurrency(amount, currency = 'USD') {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount ?? 0);
}

export function formatHour(hour) {
  if (hour === 0) return '12 AM';
  if (hour === 12) return '12 PM';
  if (hour < 12) return `${hour} AM`;
  return `${hour - 12} PM`;
}

/** Thermal line amounts without symbol (currency shown once on header/total). */
export function formatReceiptPlainAmount(amount) {
  const n = Number(amount) || 0;
  return n.toFixed(2);
}

/**
 * Receipt/total line: ISO 4217 code + amount only (ASCII). Avoids ₺ and other symbols
 * that thermal printers often print as wrong glyphs (e.g. "TRYR") under limited code pages.
 */
export function formatReceiptCurrency(amount, currency = 'USD') {
  const letters = String(currency || 'USD')
    .toUpperCase()
    .replace(/[^A-Z]/g, '');
  const code = letters.slice(0, 3) || 'USD';
  const n = Number(amount) || 0;
  const num = n.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${code} ${num}`;
}
